import Form from 'Components/Form/FormWrapper';
import React, {useEffect, useState} from 'react';
import {getCreateSRError, getSRErrorMessage} from 'Utils/helpers/ErrorHandler';
import {
  bookCashbackEventDetails,
  bookCashbackSRSection,
  buttonList,
  hiddenAddressFields,
} from './BookCashbackEvent';
import {initialValues, validationSchema} from './bookCashbackEventSchema';
import {Button, Card, Checkbox, Flex, Row, theme, Typography} from 'antd';
import SnackBar from 'Components/SnackBar';
import Wrapper from 'Components/Wrapper';
import {Queries} from 'GQL/GQLConstants';
import {gqlCall} from 'GQL/utils';
import {useSnackBar} from 'Hooks';
import {isUpdateSRList} from 'Redux/Slices/SRListFilter';
import {searchSRByID} from 'Redux/Slices/selectedSR';
import {createSR, updateSR} from 'Redux/Slices/serviceRequest';
import {
  CREATE_SR_CANCEL_ERROR,
  SR_STATUS,
  SR_TYPES,
  CREATE_SR_ERROR,
  UPDATE_SR_ERROR,
} from 'Utils/constants/genericConstants';
import {
  getBookingFee,
  getCurrency,
  getDeliveryAddress,
  getNotificationParams,
  getSeatDetails,
  getTicketItemDetails,
  getTotalActualPrice,
  hideShowFormFields,
  isLastCashbackBooking,
  isMemberEligibleForCashback,
  isPaymentSuccessful,
} from 'Utils/helpers/BookCashbckSR';
import {
  dateConversionIsoToLocal,
  dateConversionToISOFormatIgnoreTimeZone,
  getDate,
} from 'Utils/helpers/DateValidation';
import {getMemberCashbackEligibility} from 'Utils/helpers/MemberDetails';
import {parseToFloat, roundOff} from 'Utils/helpers/Numeric';
import {updateFormContent} from 'Utils/helpers/SRDetailViewHelper';
import {isDisableFormFields, sortTable} from 'Utils/helpers/SRListHelpers';
import {useDispatch, useSelector} from 'react-redux';
import AddTicketDialog from './components/AddTicketDialog';
import TicketListView from './components/TicketListView';
import {gqlTransactionDashboardSearch} from 'GQL/MethodsBFF/ServiceRequest';
import {v4 as uuidv4} from 'uuid';
// import LinkTransactionDialog from './components/LinkTransactionDialog';
import TableView from 'Components/TableView';
import {getTRDashboardListGirdData} from 'Pages/TransactionsDashboard/components/TRDashboardListGridDataSource';
import {SortOrder} from 'Utils/enums';
import {FORMAT_TYPE} from 'Utils/constants/DateFormat';

interface IProps {
  srFormDetails?: any;
  closeDialogMethod?: any;
}

const BookCashbackEventSR: React.FC<IProps> = (props) => {
  const {token}: any = theme.useToken();
  const [bcformFields, setBCFormFields] = useState<any>(bookCashbackSRSection);
  const [bcEventformFields, setBCEventFormFields] = useState<any>(bookCashbackEventDetails);
  const [buttonSection, setButtonSection] = useState(buttonList);
  const [initialFormValues, setInitialFormValues] = useState<any>({...initialValues});
  const [forceUpdate, setForceUpdate] = useState(0);
  const ownerID = useSelector((state: any) => state?.login?.userName);
  const selectedSR = useSelector((state: any) => state.selectedSR?.getServiceRequestById);
  const tenantConfig = useSelector((state: any) => state?.login?.tenantConfig);
  const {membershipEnabled} = tenantConfig;
  const selectedMemberDetails = useSelector((state: any) => state?.selectedMember).selectedMember;
  const [ticketItemDetails, setTicketItemDetails] = useState<any[]>([]);
  const dispatch = useDispatch();
  const [error, setError] = useState('');
  const [isSnackBarOpen, closeSnackBar] = useSnackBar(error);
  const [openAddTicketDialog, isOpenTicketDialog] = useState(false);
  const [ticket, setTicket] = useState<any[]>([]);
  const [currentTicketItemId, setCurrentTicketItemId] = useState<string>('');
  const [deletedTicketLineIds] = useState<string[]>([]);
  const [conversionRate, setConversionRate] = useState<number>(1);
  const loginDetails = useSelector((state: any) => state?.login);
  const [transactionTableData, setTransactionTableData] = useState<any[]>([]);
  const [noCashback, setNoCashback] = useState<boolean>(false);

  let memberCashbackEligibility;

  const fetchTransactions = async () => {
    let payload = {
      tenantId: loginDetails?.tenantID,
      claimId: selectedSR.claimId, //'169', //selectedSR.claimId,
      userGroupId: selectedMemberDetails?.membershipId,
    };
    const headers = {
      'tenant-id': loginDetails?.tenantID,
      // 'tenant-id': 5000005,
      'x-correlation-id': uuidv4(),
      Authorization: `Bearer ${loginDetails?.loginInfo?.access_token}`,
    };
    let response = await gqlTransactionDashboardSearch(payload, headers);
    let data: any = response.data.getAllClaimedOffer[0].claimedOffers;
    let tempTableData: any = [];

    (data || []).forEach((tableData) => {
      tempTableData.push({
        membership: tableData?.customerId,
        id: tableData.id,
        claimType: tableData.claimType,
        status: tableData.status,
        //owner: tableData?.owner?.userName || '',
        createdDate: dateConversionIsoToLocal(
          tableData?.claimDateTime,
          FORMAT_TYPE.DATE_TIME,
          '',
          tenantConfig?.locale,
        ),
        offerType: tableData.offerType,
        //summary: tableData.summary,
        transactionData: tableData,
      });
    });

    let resp = sortTable(
      tempTableData,
      'membership',
      'membership',
      SortOrder.ASCENDING,
      tenantConfig?.locale,
    );

    setTransactionTableData(resp.tableData);
  };

  useEffect(() => {
    //  getCashbackEligibility();
    if (selectedSR) {
      if (selectedSR.claimId) {
        fetchTransactions();
        // setIsLinkTransactionDisabled(true);
      }
      // else {
      // setIsLinkTransactionDisabled(false);
      // }
      updateSRFormValues();
      if (checkSrStutus()) {
        setformFields(true);
      } else {
        setformFields(false);
      }
    } else {
      setformFields(false);
      setBCFormFields(bookCashbackSRSection);
      setBCEventFormFields(bookCashbackEventDetails);
      selectedMemberDetials();
      setBCFormFields(hideShowFormFields(bcformFields, hiddenAddressFields, true));
      confirmedSRFieldsRequired(false);
      setformFields(false);
    }
    const ticketLineId =
      (selectedSR?.additionalData?.units &&
        selectedSR?.additionalData.units.length > 0 &&
        selectedSR?.additionalData.units[0]?.additionalInfo?.ticketLineId) ||
      '';
    setCurrentTicketItemId(ticketLineId);
  }, [selectedSR]);

  const getCashbackEligibility = async (formValues, additionalData?) => {
    if (checkSrStutus()) {
      formValues.isEligibleForCashback = additionalData?.isEligibleForCashback === false;
      formValues.isLastCashbackBooking = additionalData?.isLastCashbackBooking;
    } else {
      const headers = {
        'tenant-id': loginDetails?.tenantID,
        'user-access-token': loginDetails?.loginInfo?.access_token,
        'client-access-token': loginDetails?.loginInfo?.service_token,
      };
      memberCashbackEligibility = await getMemberCashbackEligibility(
        selectedMemberDetails,
        headers,
      );
      formValues.isEligibleForCashback =
        isMemberEligibleForCashback(memberCashbackEligibility?.cashback) === false;
      formValues.isLastCashbackBooking = isLastCashbackBooking(memberCashbackEligibility?.cashback);
    }
    return true;
  };

  const selectedMemberDetials = async () => {
    const selectedMember = selectedMemberDetails.currentMemberDetails;
    // New object instead of mutating the shared module-level `initialValues`,
    // which leaked one member's contact details into the next member's new SR.
    const memberFormValues = {
      ...initialFormValues,
      phoneNumber: selectedMember?.homePhone,
      mobileNumber: selectedMember?.mobilePhone,
      alternatePhoneNumber: selectedMember?.businessPhone,
      alternateEmail: selectedMember?.alternateEmail
        ? selectedMember?.alternateEmail
        : selectedMember?.clientEmail,
    };
    if (await getCashbackEligibility(memberFormValues)) setInitialFormValues(memberFormValues);
  };
  const updateSRFormValues = async () => {
    const {additionalData} = selectedSR;
    const formValues = {
      ...additionalData,
      venueName: additionalData?.details?.venue,
      eventName: additionalData?.details?.eventName,
      eventCategory: additionalData?.details?.category,
      eventDateTime: getDate(additionalData?.details?.dateTime),
      ...additionalData?.deliveryAddress,
      addressLineOne: additionalData?.deliveryAddress?.addressLine1,
      addressLineTwo: additionalData?.deliveryAddress?.addressLine2,
      addressLineThree: additionalData?.deliveryAddress?.addressLine3,
      seatDetails: getSeatDetails(additionalData.details?.seats),
    };
    if (await getCashbackEligibility(formValues, additionalData)) setInitialFormValues(formValues);
    setTicketItemDetails(additionalData?.units);
    setConversionRate(selectedSR.additionalData.conversionRate || 1);
    setBCFormFields(
      hideShowFormFields(bcformFields, hiddenAddressFields, formValues.isUseMailingAddress),
    );
  };
  const handleFormSubmit = (values) => {
    createSrRequest(values);
  };

  const createAdditionalData = async (formValues) => {
    const additionalData = selectedSR?.additionalData;

    const selectedMember = selectedMemberDetails.currentMemberDetails;
    let solCurrency = getCurrency(selectedMemberDetails);
    let srCurrency = formValues.currency;
    if (solCurrency !== srCurrency) {
      if (conversionRate === 1) {
        const request = {
          fromCurrency: srCurrency,
          toCurrency: solCurrency,
        };
        const resp = await gqlCall(Queries.GET_CONVERSION_RATE, request);
        if (resp && resp.geCurrencyConversionRate) {
          let rate = parseToFloat(resp.geCurrencyConversionRate);
          setConversionRate(rate);
        }
      }
    } else {
      setConversionRate(1);
    }

    const totalAmount = await getTotalActualPrice(
      ticketItemDetails,
      formValues.postageFee,
      conversionRate,
    );

    let bookingDate =
      selectedSR?.additionalData &&
      isPaymentSuccessful(selectedSR) &&
      (additionalData?.bookingDate == '' || additionalData?.bookingDate == null)
        ? dateConversionToISOFormatIgnoreTimeZone(new Date())
        : additionalData?.bookingDate;
    return {
      source: 'ng-engage',
      bookingReference: formValues.bookingReference,
      currency: solCurrency,
      unitCurrency: formValues.currency,
      isAvailCashback: !noCashback,
      customerEmail: selectedMember.primaryEmail,
      customerFirstName: selectedMember.firstName,
      customerLastName: selectedMember.lastName,
      customerPhoneNumber: selectedMember.mobilePhone,
      service: props.srFormDetails?.serviceType,
      details: {
        dateTime: dateConversionToISOFormatIgnoreTimeZone(new Date(formValues.eventDateTime)),
        eventName: formValues.eventName,
        category: formValues.eventCategory,
        seats: [
          {
            block: '',
            row: '',
            seat: '',
            additionalDetails: formValues.seatDetails,
          },
        ],
        venue: formValues.venueName,
      },
      totalBookingFee: roundOff(
        getBookingFee(ticketItemDetails, 'bookingFee', 'quantity') * conversionRate,
        2,
      ),
      postageFee: roundOff(formValues.postageFee, 2),
      units: [...ticketItemDetails],
      totalActualPrice: totalAmount,
      totalPriceAfterCashback: roundOff(parseToFloat(formValues.totalPriceAfterCashback), 2),
      totalCashback: roundOff(parseToFloat(formValues.totalCashback), 2),
      extraCashbackPercentage: parseToFloat(formValues.extraCashbackPercentage),
      extraCashback: roundOff(parseToFloat(formValues.extraCashback), 2),
      payments: additionalData?.payments || [],
      deliveryAddress: getDeliveryAddress(formValues, selectedMember),
      deliveryName: formValues.isUseMailingAddress
        ? selectedMember.firstName + ' ' + selectedMember.lastName
        : formValues.deliveryName,
      deliveryType: formValues.deliveryType,
      ticketProvider: formValues.ticketProvider,
      bookingDate: bookingDate || null,
      cancellationReason: formValues.cancellationReason,
      isEligibleForCashback: formValues.isEligibleForCashback === false,
      isCashbackProcessed: additionalData?.isCashbackProcessed || false,
      channel: formValues.channel,
      subStatus: formValues.subStatus,
      comments: formValues.comments,
      alternateEmail: formValues.alternateEmail,
      isLastCashbackBooking: formValues.isLastCashbackBooking,
      onSaleRegRequestId: additionalData?.onSaleRegRequestId,
      isUseMailingAddress: formValues.isUseMailingAddress,
      deletedLineIdList: deletedTicketLineIds || [],
      conversionRate: conversionRate,
      onSalePvId: additionalData?.onSalePvId,
    };
  };

  const createSrRequest = async (formValues) => {
    let status = selectedSR?.srStatus || SR_STATUS.OPEN;
    // Validate mandatory fields for Confirmed action
    if (formValues?.buttonAction === 'Confirmed') {
      confirmedSRFieldsRequired(true);
      if (
        !isPaymentSuccessful(selectedSR) ||
        !formValues.deliveryType ||
        !formValues.seatDetails ||
        !formValues.bookingReference
      ) {
        setError('Please ensure that the payments are present to proceed');
        confirmedSRFieldsRequired(false);
        setformFields(false);

        // Force form re-render
        setForceUpdate((prev) => prev + 1);

        return false;
      }
      status = SR_STATUS.CONFIRMED;
    } else if (formValues?.buttonAction === 'Save') {
      status = selectedSR?.srStatus || SR_STATUS.OPEN;
      confirmedSRFieldsRequired(false);
    } else if (formValues?.buttonAction === 'Cancel') {
      status = SR_STATUS.CANCELLED;
      confirmedSRFieldsRequired(false);
      if (formValues.cancellationReason === '') {
        setError(CREATE_SR_CANCEL_ERROR);
        return false;
      }
    }

    // Only proceed with API call if we have member details and all validations passed
    if (!selectedMemberDetails?.currentMemberDetails) {
      setError('Member details not found');
      return false;
    }

    const selectedMember = selectedMemberDetails.currentMemberDetails;
    const notificationParams = getNotificationParams(
      selectedMemberDetails,
      formValues.alternateEmail,
      membershipEnabled,
    );

    // Prepare the request data
    const additionalData = await createAdditionalData(formValues);
    if (!additionalData) {
      setError('Failed to prepare request data');
      return false;
    }

    if (selectedSR?.id) {
      let updateSRVariable = {
        id: selectedSR?.id,
        requestObj: {
          commands: [
            {
              commandName: 'updateSR',
              commandId: selectedSR?.id,
              ...selectedSR,
              summary: formValues.eventName,
              status: status,
              userId: selectedMember?.userId,
              userGroupId: selectedMemberDetails?.membershipId,
              additionalData: additionalData,
              audit: {...selectedSR.audit, modifiedBy: ownerID.toLowerCase()},
            },
          ],
        },
        notificationParams: notificationParams,
      };

      try {
        let resp = await dispatch(updateSR(updateSRVariable)).unwrap();

        let srUpdateStatus = resp?.data?.updateServiceRequest[0]?.status;
        if (srUpdateStatus?.toUpperCase() === 'SUCCESS') {
          let payload = {
            id: selectedSR?.id,
          };
          await dispatch(searchSRByID(payload)).unwrap();
          props.closeDialogMethod(true);
          dispatch(
            isUpdateSRList({
              isRefreshSRList: true,
            }),
          );
          setError('');
        } else if (srUpdateStatus?.toUpperCase() === 'FAILURE') {
          let srUpdateErrors = resp?.data?.updateServiceRequest?.[0]?.errors;
          setError(getSRErrorMessage(srUpdateErrors, UPDATE_SR_ERROR));
          // Enable buttons after failed confirmation
          if (formValues?.buttonAction === 'Confirmed') {
            setformFields(false);
          }
        } else {
          setError('Something Went Wrong');
          if (formValues?.buttonAction === 'Confirmed') {
            setformFields(false);
          }
        }
      } catch (error: any) {
        setError(error?.message || UPDATE_SR_ERROR);
        // Enable buttons after error
        if (formValues?.buttonAction === 'Confirmed') {
          setformFields(false);
        }
      }
    } else {
      let createRequest = {
        serviceRequest: {
          id: null,
          type: props.srFormDetails.srType,
          subType: '',
          member: {
            id: selectedMember.memberId,
            membershipId: selectedMemberDetails.membershipId,
            // membershipNumber: selectedMemberDetails?.membershipNumber || null,
          },
          userId: selectedMember?.userId || null,
          userGroupId: selectedMemberDetails?.membershipId || null,
          owner: null,
          activities: [],
          description: '',
          summary: formValues.eventName,
          status: status,
          additionalData: additionalData,
          audit: {
            createdBy: ownerID.toLowerCase(),
          },
        },
        notificationParams: notificationParams,
      };
      let resp = await dispatch(createSR(createRequest)).unwrap();
      const createError = getCreateSRError(resp, CREATE_SR_ERROR);
      if (createError) {
        // Keep the modal (and everything the agent typed) open and say why.
        setError(createError);
        return false;
      }
      if (resp) {
        props.closeDialogMethod(true);
        let payload = {
          id: resp.data.createServiceRequest.id,
        };
        await dispatch(searchSRByID(payload)).unwrap();
        dispatch(
          isUpdateSRList({
            isRefreshSRList: true,
          }),
        );
      }
    }
  };

  const clearMessageOnClose = () => setError('');

  const onUpdateItemClick = (data) => {
    setCurrentTicketItemId(data.ticketLineId);
    setTicket(data);
    isOpenTicketDialog(true);
  };

  const onRemoveItemClick = (data) => {
    setCurrentTicketItemId(data?.ticketLineId);
    if (checkSrStutus()) return;
    if (currentTicketItemId === data?.ticketLineId) {
      setCurrentTicketItemId('');
    }
    let tempArr: any[] = [];
    deletedTicketLineIds.push(data?.ticketLineId);
    for (let i = 0; i < ticketItemDetails.length; i++) {
      if (ticketItemDetails[i]?.additionalInfo?.ticketLineId === data?.ticketLineId) {
        continue;
      }
      tempArr.push(ticketItemDetails[i]);
    }
    setTicketItemDetails(tempArr);
  };

  const handleAddTicketClick = async () => {
    setTicket([]);
    setCurrentTicketItemId('');
    isOpenTicketDialog(true);
  };

  const handleTicketOnSubmit = (ticket) => {
    if (ticket['buttonAction'] === 'Add' || ticket['buttonAction'] === 'Update') {
      if (currentTicketItemId) {
        let tempArr = [...ticketItemDetails];
        let ticketItemIndex = tempArr.findIndex(
          (item) => item?.additionalInfo?.ticketLineId === currentTicketItemId,
        );
        let ticketItem = getTicketItemDetails(ticket, tempArr, noCashback);
        ticketItem.additionalInfo.ticketLineId = currentTicketItemId;
        tempArr[ticketItemIndex] = ticketItem;
        setTicketItemDetails(tempArr);
      } else {
        let tempArr = (ticketItemDetails && [...ticketItemDetails]) || [];
        const ticketItem = getTicketItemDetails(ticket, tempArr, noCashback);
        tempArr.push(ticketItem);
        setCurrentTicketItemId(ticketItem.additionalInfo.ticketLineId);
        setTicketItemDetails(tempArr);
      }
      setTicket([]);
    }
  };

  const handleMailingAddressClick = (e, setField) => {
    setBCFormFields(hideShowFormFields(bcformFields, hiddenAddressFields, e.target.checked));
    let updatedFormContent = updateFormContent(bcformFields, {
      deliveryName: {
        targetAttribute: 'required',
        targetValue: !e.target.checked,
      },
    });
    setBCFormFields(updatedFormContent);
    // if (e.target.checked) {
    //   const selectedMember = selectedMemberDetails.currentMemberDetails;
    //   setField('mobileNumber', selectedMember?.mobilePhone);
    //   setField('alternateEmail', selectedMember?.clientEmail);
    // } else {
    //    setField('mobileNumber', '');
    //   setField('alternateEmail', '');
    // }
  };

  const confirmedSRFieldsRequired = (value) => {
    let updatedFormContent = updateFormContent(bcformFields, {
      deliveryType: {
        targetAttribute: 'required',
        targetValue: value,
      },
      ticketProvider: {
        targetAttribute: 'required',
        targetValue: value,
      },
      channel: {
        targetAttribute: 'required',
        targetValue: value,
      },
    });
    setBCFormFields(updatedFormContent);

    let targetFormFields = {
      bookingReference: {
        targetAttribute: 'required',
        targetValue: value,
      },
      seatDetails: {
        targetAttribute: 'required',
        targetValue: value,
      },
      eventName: {
        targetAttribute: 'required',
        targetValue: value,
      },
      venueName: {
        targetAttribute: 'required',
        targetValue: value,
      },
    };

    let updatedEventFormContent = updateFormContent(bcEventformFields, targetFormFields);
    setBCEventFormFields(updatedEventFormContent);
  };

  const checkSrStutus = () => {
    if (
      selectedSR &&
      (selectedSR.type === SR_TYPES.BOOK_CASHBACK_EVENT ||
        selectedSR.type === SR_TYPES.CINEMA_ECODE ||
        selectedSR.type === SR_TYPES.FILM_RENTAL_ECODE) &&
      (selectedSR.status === SR_STATUS.CANCELLED || selectedSR.status === SR_STATUS.CONFIRMED)
    ) {
      return true;
    }
  };
  const customEvents = {
    isUseMailingAddress: {onChange: handleMailingAddressClick},
  };
  const setformFields = (isDisabled) => {
    // First update button states directly
    const newButtonSection = {
      ...buttonSection,
      fields: buttonSection.fields.map((field) => ({
        ...field,
        isDisabled: isDisabled,
      })),
    };
    setButtonSection(newButtonSection);

    // Then update form fields
    let disabledFormBCFields = updateFormContent(
      bcformFields,
      isDisableFormFields(bcformFields.fields, isDisabled),
    );
    setBCFormFields(disabledFormBCFields);

    let disabledFormEventFields = updateFormContent(
      bcEventformFields,
      isDisableFormFields(bcEventformFields.fields, isDisabled),
    );
    setBCEventFormFields(disabledFormEventFields);

    // Keep certain fields always disabled
    const fixedDisabledFields = {
      isEligibleForCashback: {
        targetAttribute: 'isDisabled',
        targetValue: true,
      },
      isLastCashbackBooking: {
        targetAttribute: 'isDisabled',
        targetValue: true,
      },
    };
    setBCFormFields(updateFormContent(bcformFields, fixedDisabledFields));

    const eventFixedDisabledFields = {
      bookingDate: {
        targetAttribute: 'isDisabled',
        targetValue: true,
      },
      totalBookingFee: {
        targetAttribute: 'isDisabled',
        targetValue: true,
      },
      totalActualPrice: {
        targetAttribute: 'isDisabled',
        targetValue: true,
      },
      extraCashback: {
        targetAttribute: 'isDisabled',
        targetValue: true,
      },
      totalCashback: {
        targetAttribute: 'isDisabled',
        targetValue: true,
      },
      totalPriceAfterCashback: {
        targetAttribute: 'isDisabled',
        targetValue: true,
      },
    };
    setBCEventFormFields(updateFormContent(bcEventformFields, eventFixedDisabledFields));
  };
  // const handleLinkTransactionClick = () => {
  //   setIsLinkTransactionDialogOpen(true);
  // };

  // const closeLinkTransactionDialog = () => {
  //   setIsLinkTransactionDialogOpen(false);
  // };

  return (
    <Wrapper>
      <SnackBar
        isSnackBarOpen={isSnackBarOpen}
        closeSnackBar={closeSnackBar}
        errorMessage={error}
        clearMessageOnClose={clearMessageOnClose}
      />
      <Form
        key={forceUpdate}
        onSubmit={handleFormSubmit}
        validationSchema={validationSchema}
        initialValues={initialFormValues}
        section1={bcformFields}
        section2={bcEventformFields}
        buttonStack={buttonSection}
        customEvents={customEvents}
      />
      <Card style={{marginTop: 16, marginBottom: 16}}>
        <Flex vertical gap={16}>
          <Flex wrap justify="space-between" align="center" gap={8}>
            <Typography.Title level={4} style={{margin: 0}}>
              Ticket Details
            </Typography.Title>

            <Flex wrap align="center" gap={4}>
              <Checkbox
                checked={ticket?.[0]?.isNoCashback || noCashback}
                style={{color: token.colorPrimary}}
                onChange={(e) => setNoCashback(e.target.checked)}
                disabled={ticketItemDetails?.length > 0 ? true : false}
              />
              <Typography.Text style={{marginRight: 10}}>No Cashback</Typography.Text>
              <Button type="primary" onClick={handleAddTicketClick} disabled={checkSrStutus()}>
                Add
              </Button>
            </Flex>
          </Flex>
          <Row gutter={16}>
            <TicketListView
              tableData={ticketItemDetails}
              onRemoveItemClick={onRemoveItemClick}
              onUpdateItemClick={onUpdateItemClick}
            />
          </Row>
        </Flex>
        <AddTicketDialog
          openAddTicketDialog={openAddTicketDialog}
          isOpenTicketDialog={isOpenTicketDialog}
          handleOnSubmit={handleTicketOnSubmit}
          ticket={ticket}
          setTicket={setTicket}
        />
      </Card>

      <Card style={{marginTop: 16, marginBottom: 16}}>
        <Flex vertical gap={16}>
          {transactionTableData && (
            <>
              <Typography.Title level={4} style={{margin: 0}}>
                Linked Transactions
              </Typography.Title>
              <TableView
                {...getTRDashboardListGirdData(
                  transactionTableData,
                  SortOrder.DESCENDING,
                  '',
                  true,
                )}
              />
            </>
          )}
        </Flex>
      </Card>
    </Wrapper>
  );
};
export default BookCashbackEventSR;
